import * as Yup from "yup";

export const SupplierSchema = Yup.object().shape({
  name: Yup.string().min(3, "The name is too short").max(25, "The name is too long").required("Please enter the product name"),
});